export * from "./audio";
export * from "./camera";
export * from "./core";
export * from "./transition";

import Color from "./math/Color";
import Vector2 from "./math/Vector2";

import * as math from "./math";
import * as tracking from "./tracking";
import * as utils from "./utils";

import settings from "./settings";

export {
    Color,
    Vector2,

    math,
    settings,
    tracking,

    utils
}

global.P3 = exports;